import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Utensils, Leaf, Droplets, FileText, ArrowRight } from 'lucide-react';
const services = [{
  title: 'Food Safety',
  description: 'Restaurant inspections, food handler training, and foodborne illness investigations.',
  icon: Utensils,
  link: '#food-safety'
}, {
  title: 'Environmental Health',
  description: 'Air quality monitoring, hazardous waste management, and vector control services.',
  icon: Leaf,
  link: '#environmental-health'
}, {
  title: 'Water Quality',
  description: 'Testing and regulation of public pools, private wells, and drinking water systems.',
  icon: Droplets,
  link: '#water-quality'
}, {
  title: 'Permits & Licensing',
  description: 'Applications and renewals for health permits, birth certificates, and death records.',
  icon: FileText,
  link: '#permits'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 50,
      damping: 15
    }
  }
};
export function ServiceCards() {
  return <section id="services" className="py-20 bg-gov-light" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-147">
            Core Public Health Services
          </h2>
          <div className="w-24 h-1.5 bg-gov-amber mx-auto mb-6 rounded-full" data-id="element-148"></div>
          <p className="text-lg text-gov-slate" data-id="element-149">
            We provide essential services to protect, promote, and improve the
            health of all people in Franklin County.
          </p>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-150">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.a href={service.link} key={index} variants={itemVariants} className="group flex flex-col bg-white rounded-xl p-8 shadow-sm border border-gov-border hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300" data-id="element-151">
                <div className="w-14 h-14 bg-gov-navy/5 text-gov-navy rounded-lg flex items-center justify-center mb-6 group-hover:bg-gov-navy group-hover:text-white transition-colors duration-300" data-id="element-152">
                  <Icon className="w-7 h-7" data-id="element-153" />
                </div>
                <h3 className="text-xl font-bold mb-3 group-hover:text-gov-navy transition-colors" data-id="element-154">
                  {service.title}
                </h3>
                <p className="text-gov-slate mb-6 flex-grow leading-relaxed" data-id="element-155">
                  {service.description}
                </p>
                <div className="flex items-center text-gov-navy font-semibold text-sm mt-auto group-hover:text-gov-amber transition-colors" data-id="element-156">
                  Learn more{' '}
                  <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-157" />
                </div>
              </motion.a>;
        })}
        </motion.div>

        <div className="mt-16 text-center" data-id="element-158">
          <a href="#all-services" className="inline-flex items-center justify-center px-6 py-3 border border-gov-border bg-white text-gov-navy font-semibold rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-159">
            View All Department Services
          </a>
        </div>
      </div>
    </section>;
}